import { ABBaseComponent, defineComponent } from './ab-base-component.js';

class ABMobileDrawer extends ABBaseComponent {
  connectedCallback() {
    this.dialog = this.$('dialog');
    this.levels = this.$$('[data-level]');

    // Open trigger (hamburger button in header — outside this component)
    document.querySelector('[data-mobile-menu-trigger]')?.addEventListener('click', () => {
      this.open();
    });

    // Close button
    this.$('[data-close-drawer]')?.addEventListener('click', () => {
      this.close();
    });

    // Drill-down buttons
    this.$$('[data-drill-target]').forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-drill-target');
        this.showLevel(targetId);
      });
    });

    // Back buttons
    this.$$('[data-drill-back]').forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-drill-back');
        this.showLevel(targetId);
      });
    });

    // Close on backdrop click (dialog provides this natively)
    this.dialog?.addEventListener('click', (e) => {
      if (e.target === this.dialog) {
        this.close();
      }
    });
  }

  open() {
    this.dialog?.showModal();
    // Reset to level 1
    this.showLevel('level-1');
  }

  close() {
    this.dialog?.close();
  }

  showLevel(levelId) {
    // Hide all levels, show target
    this.levels.forEach(level => {
      level.hidden = level.id !== levelId;
    });
    // Focus first interactive element in the new level
    const target = this.$(`#${levelId}`);
    const firstFocusable = target?.querySelector('a, button');
    firstFocusable?.focus();
  }
}

defineComponent('ab-mobile-drawer', ABMobileDrawer);
